import Uppy from '@uppy/core'
// import { Uppy as UppyForm } from '@uppy/form'
import XHRUpload from '@uppy/xhr-upload'
import Dashboard from '@uppy/dashboard'

window.Uppy = Uppy;
// window.Form = UppyForm;
window.XHRUpload = XHRUpload;
window.Dashboard = Dashboard;